import React, { useState } from "react";

export function ProcessCard({ process, configuration, openModal }) {
  const [showAllGroups, setShowAllGroups] = useState(false);
  const [showAllRoles, setShowAllRoles] = useState(false);

  const handleToggleGroups = (e) => {
    e.preventDefault();
    setShowAllGroups(!showAllGroups);
  };

  const handleToggleRoles = (e) => {
    e.preventDefault();
    setShowAllRoles(!showAllRoles);
  };

  const itemsToShowGroups = showAllGroups
    ? process.groups
    : process.groups.slice(0, 1);
  const itemsToShowRoles = showAllRoles
    ? process.roles
    : process.roles.slice(0, 1);

  let url = process.url;
  if (process.current_phase?.private) url = url; // Login, checar si el user esta log primero TO DO... 

  let phaseInfo = "";
  let iconphase = "";
  if (process.current_phase) {
    iconphase = `icon-${process.current_phase.phase_type}`;
    phaseInfo = (
      <>
        {process.multiphase ? (
          <>
            <i
              className="icon-processes"
              title={configuration.translations.multiPhaseText}
            ></i>
            <span>{configuration.translations.multiPhaseText}</span>
          </>
        ) : (
          <>
            <i
              className={iconphase}
              title={process.current_phase.phase_type_display}
            ></i>
            <span>{process.current_phase.phase_type_display}</span>
          </>
        )}
      </>
    );
  }

  let accesibleStatus = process?.accesible.status; // Chequear como y dodne se configura esto y que pasa con los procesos privados

  return (
    <>    
      <a className="card card-primary text-decoration-none mt-3 mb-3 card-hover shadow-sm" 
      href={accesibleStatus ? url : "#"}
      onClick={!accesibleStatus ? openModal : null}
      >
        <div className="row g-0 min-height-card-primary">
          {/* Col Text */}
          <div className="col-12 col-md-6 p-2 d-flex">
            <div className="card-body d-flex flex-column align-items-start gap-1">
              {/* Phase & Private Pill */}
              <span className="fs-7 mb-2 d-flex align-items-center gap-1">
                {process.current_phase?.private && <i className="fa-solid fa-lock"></i>}
                {phaseInfo}
              </span>
              {/* Card Title */}
              <h4 className="card-title h6">{process.name}</h4>
              {/* Participa Btn */}
              <div className="mt-auto fw-bold text-uppercase fs-7">
                <span>{configuration.translations.takePart}</span>
                <i className="fa-solid fa-arrow-right ms-1"></i>
              </div>
            </div>
          </div>
          {/* Col Img & Badges */}
          <div className="col-12 col-md-6 position-relative">
            {/* Badges Container */}
            <div className="position-absolute top-0 end-0 z-2 m-3 d-flex flex-column gap-2 align-items-end">
              {/* Groups */}
              {process.groups.length > 0 && (
                <div
                  className="d-flex align-items-center gap-2 badge text-bg-warning"
                  onClick={process.groups.length > 1 ? handleToggleGroups : null}
                >
                  <i className="icon-educacion"></i>
                  <div className="d-flex flex-column align-items-start gap-1">
                    {itemsToShowGroups.map((group, index) => (
                      <span key={index}>
                        {group}
                      </span>
                    ))}
                  </div>
                  {process.groups.length > 1 && (
                    <i
                      className={
                        showAllGroups
                          ? `fa-solid fa-chevron-up`
                          : `fa-solid fa-chevron-down`
                      }
                    ></i>
                  )}
                </div>
              )}
              {/* Role */}
              {process.roles.length > 0 && (
                <div
                  className="badge text-bg-light d-flex align-items-center gap-2"
                  onClick={process.roles.length > 1 ? handleToggleRoles : null}
                >
                  <i className="icon-administracion"></i>
                  <div className="d-flex flex-column align-items-start gap-1">
                    {itemsToShowRoles.map((role, index) => (
                      <span key={index}>{role}</span>
                    ))}
                  </div>
                  {process.roles.length > 1 && (
                    <i
                      className={
                        showAllRoles
                          ? `fa-solid fa-chevron-up`
                          : `fa-solid fa-chevron-down`
                      }
                    ></i>
                  )}
                </div>
              )}
            </div>
            {/* Main Img  */}
            <div className="ratio ratio-16x9 h-100">
              <img
                src={process.list_image}
                alt={process.name}
                className="w-100 h-100 object-fit-cover rounded-card-primary-img img-fluid"
                loading="lazy"
                width="200"
                height="200"
              />
            </div>
          </div>
        </div>
      </a>          
    </>
  );
}
